export const listItems = [
  {
    id: 1,
    text: "Save Time with AI driven personalized course recommendations.",
  },
  {
    id: 2,
    text: "Stay Updated Continuous learning with the latest course materials.",
  },
  {
    id: 3,
    text: "Track your progress and stay on course with personalized plans.",
  },
];
export const listItems2 = [
  {
    id: 1,
    text: "Interactive Courses",
  },
  {
    id: 2,
    text: "Track Progress",
  },
  {
    id: 3,
    text: "VR-based Training",
  },
  {
    id: 4,
    text: "Boost skills",
  },
];

export const listItems3 = [
  {
    id: 1,
    icon: "icon-tick",
    text: "Save time — Rapid AI-driven generation.",
  },
  {
    id: 2,
    icon: "icon-tick",
    text: "No Outdates — Continuous code documentation refresh.",
  },
  {
    id: 3,
    icon: "icon-tick",
    text: "Consistency — Consistent code documentation.",
  },
];
export const features = [
  {
    id: 1,
    icon: "icon-laptop-code",
    title: "Coding Superpowers",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducim blanditiis",
    link: "#",
  },
  {
    id: 2,
    icon: "icon-rocket-launch",
    title: "AI Autocomplete",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducim blanditiis",
    link: "#",
  },
  {
    id: 3,
    icon: "icon-gift",
    title: "Free Coding Forever",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducim blanditiis",
    link: "#",
  },
];

export const fileItems = [
  {
    id: 1,
    iconClass: "icon-write-1",
    title: "Generate Copy in Seconds",
    description:
      "Sed ut perspiciatis unde omnis natus see voluptatem accusantium doloremque laudays totam rem aperiam eaque quae",
    itemClass: "item-1",
  },
  {
    id: 2,
    iconClass: "icon-maintenance-1",
    title: "Highly-tuned AI tools fingertips",
    description:
      "To take trivial example which everd rtakes laborious physical exercise, except to obtain some advantage has any right",
    itemClass: "item-2",
  },
  {
    id: 3,
    iconClass: "icon-project-1",
    title: "Enter your copywriting project",
    description:
      "Sed ut perspiciatis unde omnis natus see voluptatem accusantium doloremque laudays totam rem aperiam eaque quae",
    itemClass: "item-3",
  },
];

export const boxFeatureItems = [
  {
    id: 1,
    itemClass: "item2",
    title: "Write Higher Converting Assistance Post For All",
    highlightedText: "Levels Users",
    description:
      "We denounce with righteous indignation and dislike men are beguiled and demoralized by the charms of pleasure",
    imgSrc: "/assets/images/item-background/box-feature-2.png",
  },
  {
    id: 2,
    itemClass: "item3",
    title: "Generate Blog Posts, Stories, & Even Books",
    highlightedText: "With MunAI",
    description:
      "We denounce with righteous indignation and dislike men are beguiled and demoralized by the charms of pleasure",
    imgSrc: "/assets/images/item-background/box-feature-3.png",
  },
];

export const useCases = [
  {
    id: 1,
    icon: "icon-users",
    title: "Manage Your Account",
  },
  {
    id: 2,
    icon: "icon-pen",
    title: "Generate Your Account",
  },
  {
    id: 3,
    icon: "icon-blog",
    title: "Customize Your media post",
  },
  {
    id: 4,
    icon: "icon-comment",
    title: "Engage your Social post",
  },
  {
    id: 5,
    icon: "icon-share",
    title: "Publish your social post",
  },
  {
    id: 6,
    icon: "icon-chart-line",
    title: "Analyze Media Generator",
  },
];

export const featureItems = [
  {
    id: 1,
    title: "Optimized blog posts in seconds",
    description:
      "Must explain want this mistaken see denouncing pleasure & praising",
    delay: "0s",
  },
  {
    id: 2,
    title: "AI Workflow Automation generate post",
    description:
      "Must explain want this mistaken see denouncing pleasure & praising",
    delay: "0.1s",
  },
  {
    id: 3,
    title: "Tools & templates",
    description:
      "Must explain want this mistaken see denouncing pleasure & praising",
    delay: "0.2s",
  },
];
